/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';

export default class GroupBadge extends Component {
  @action
  setNavCardOpen(value) {
    this.navCardOpen = value;
  }

  @tracked
  navCardOpen;

  onDelete() {}
}
